<dialog-header [dialogRef]="dialogRef" headerKey="FAILURE_PREVIEW"></dialog-header>
<div mat-dialog-content>
  <div class="details">
    <attribute-item *ngFor="let item of details" [item]="item" />
  </div>
  <files-list
    type="PHOTO"
    header=""
    [files]="data.photos"
    [disableUpload]="true"
    [disableDelete]="true"
    [offlineMode]="!((networkStatus$ | async) ?? true)"
    hintKey=""
  ></files-list>
  <buttons-wrapper>
    <button mat-flat-button type="button" color="primary" mat-dialog-close>{{ 'CLOSE' | translate }}</button>
  </buttons-wrapper>
</div>
